import {AfterViewInit, ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild} from "@angular/core";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {FormBuilder} from "@angular/forms";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {Medicine} from "../../../store-management/model/medicine.type";
import {ApolloQueryObservable} from "apollo-angular";
import {MedicineService} from "../../../store-management/services/medicine.service";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";

@Component({
  selector: 'vb-medicine-stickers-list',
  templateUrl: './medicine-stickers-list.component.html',
  styleUrls: ['./medicine-stickers-list.component.css']
})
export class MedicineStickersListComponent extends AbstractListView implements OnInit, AfterViewInit {

  printList: { [medicineCuid: string]: number } = {};

  @ViewChild('editAmountTmpl')
  editAmountTmpl: TemplateRef<any>;

  @ViewChild('medicinesTable')
  table: DatatableComponent;

  editable: { [cuid: string]: boolean };

  messages = {
    emptyMessage: 'Keine Medikamente auf der Liste',
    totalMessage: 'Medikamente auf der Liste'
  };

  private medicineList$: ApolloQueryObservable<any>;
  medicineList: Medicine[];

  constructor(private fb: FormBuilder, sessionActions: SessionActions,
              private medService: MedicineService, cd: ChangeDetectorRef) {

    super(sessionActions, cd);

  }

  ngOnInit() {

    this.isLoading = true;

    this.medicineList$ = this.medService.getMedicines(this.activeAdminUnitCuid$);
    this.addComponentData(this.medicineList$);

    this.dataSubscriptions.push(
      this.medicineList$.subscribe(res => {
        this.medicineList = res.data.medicines;
        this.isLoading = res.loading;
        this.rows = this.medicineList;
      })
    );

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

    this.columns = [
      {prop: 'administration_unit.label', name: 'Verwaltungseinheit', minWidth: 100, flexGrow: 2},
      {prop: 'name', name: 'Handelsname', minWidth: 100, flexGrow: 2},
      {prop: 'substances.0.substance.name', name: 'Wirkstoff', minWidth: 100, flexGrow: 2},
      {prop: 'dosage_per_capacity_string', name: 'Dosierung', minWidth: 50, flexGrow: 1, sortable: false},
      {prop: 'notes', name: 'Bemerkungen', flexGrow: 2},
      {name: 'Anzahl', cellTemplate: this.editAmountTmpl, minWidth: 50, flexGrow: 1, sortable: false}, //TODO: Enable sorting
    ];

  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    /*this.cd.detectChanges();
     // Hack for ordering
     let col = this.table.table._columns[0];
     this.table.table.onColumnResize({column: col, newValue: 50});
     this.cd.detectChanges();*/

  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.medicineList;
    } else {
      if (this.medicineList) {
        this.rows = this.medicineList.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  onCellUpdate(row, res, index) {

  }

  onAmountChanged(medicineCuid: string, amount: number) {

    if (amount && amount > 0) {
      this.printList[medicineCuid] = +amount;
    } else {
      delete this.printList[medicineCuid];
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/medicine-stickers/components/medicine-stickers-list/medicine-stickers-list.component.ts